"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _commonReact = require("@devsta/common-react");

require("../styles/_page-header.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PageHeaderWithBackground(_ref) {
  var handleFilesChange = _ref.handleFilesChange,
      title = _ref.title,
      subtitle = _ref.subtitle,
      subtitleLink = _ref.subtitleLink,
      onCreate = _ref.onCreate,
      createText = _ref.createText,
      imageUrl = _ref.imageUrl,
      buttonBusy = _ref.buttonBusy,
      hasManagePermission = _ref.hasManagePermission,
      actionBtnMobileIcon = _ref.actionBtnMobileIcon,
      actionPopupOptions = _ref.actionPopupOptions,
      history = _ref.history;
  var buttonText = imageUrl ? 'Change cover photo' : 'Add cover photo';
  var iconName = imageUrl ? 'edit' : 'addfat';
  return _react.default.createElement("div", {
    className: "page-header-with-bg",
    style: imageUrl ? {
      backgroundImage: "url(".concat(imageUrl, ")")
    } : {
      background: _vars.COLOURS.grey.nevada
    }
  }, handleFilesChange && hasManagePermission ? _react.default.createElement(_commonReact.Files, {
    onFilesChange: handleFilesChange,
    allowedTypes: ['image'],
    minFileSize: 1,
    clickable: true
  }, _react.default.createElement("div", {
    className: "page-header-with-bg__cover-photo-button"
  }, _react.default.createElement(_uiKit.Icon, {
    name: iconName,
    color: "white",
    size: 20
  }), _react.default.createElement("p", {
    className: "page-header-with-bg__cover-photo-button__text"
  }, buttonText))) : null, _react.default.createElement(_uiKit.PageHeader, {
    title: title,
    subtitle: subtitle,
    subtitleLink: subtitleLink,
    actionBtnText: hasManagePermission ? createText : null,
    actionBtnOnClick: onCreate,
    actionBtnBusy: buttonBusy,
    titleIconColor: "white",
    alwaysShowSubtitle: true,
    actionBtnMobileIcon: actionBtnMobileIcon,
    actionPopupOptions: hasManagePermission ? actionPopupOptions : void 0,
    history: history
  }));
}

var _default = (0, _react.memo)(PageHeaderWithBackground);

exports.default = _default;